// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6bd07c95991d848cfedd","351":"b569cc3cf288ece45668","691":"b0d37bbe9cb88701a496"}[chunkId] + ".js";
};